import { render } from "./TopNavigation.vue?vue&type=template&id=156f0784"
import script from "./TopNavigation.vue?vue&type=script&lang=js"
export * from "./TopNavigation.vue?vue&type=script&lang=js"
script.render = render

export default script